import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Card, CardContent } from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { orpc } from '@/lib/orpcClient'

export const Route = createFileRoute('/hr/me/expense-claims')({
  component: MyExpenseClaimsPage,
})

function MyExpenseClaimsPage() {
  const { data, isLoading } = useQuery(orpc.hr.me.listOwnExpenseClaims.queryOptions({ input: {} }))
  const rows = (data ?? []) as Array<{
    id: number
    title: string | null
    totalAmount: string | number | null
    status: string | null
    submittedAt: string | null
  }>

  return (
    <Card>
      <CardContent className="p-0">
        {isLoading ? (
          <div className="p-6 text-muted-foreground">Loading...</div>
        ) : rows.length === 0 ? (
          <div className="p-6 text-muted-foreground">No expense claims yet.</div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Title</TableHead>
                <TableHead>Total</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Submitted</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.id}>
                  <TableCell>{r.title ?? '-'}</TableCell>
                  <TableCell>{r.totalAmount ?? '-'}</TableCell>
                  <TableCell>{r.status ?? '-'}</TableCell>
                  <TableCell>
                    {r.submittedAt ? new Date(r.submittedAt).toLocaleDateString() : '-'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  )
}
